<template>
<div>
    <header>
        <div class="inr">
            <span class="prev">
                <a @click="$router.go(-1)">
                    <img src="@/assets/image/icon-prev.png" alt="뒤로가기">
                </a>
            </span>
            <h1>포인트 사용 내역</h1>
        </div>
    </header>
    <Footer />
    <main id="sub" class="service">
        <div class="inr">
            <div class="main-content-wrap">
                <!-- 포인트 사용 내역 -->
                <div class="contract-summary">
                    <div class="contract-address">
                        <strong class="contract-add">[{{name}}님] <span class="font-prompt"> 보유 포인트</span></strong>
                    </div>
                    <div class="contract-price-wrap" s>
                        <div class="contract-price">
                            <p class="price after-arrow">
                                <img src="@/assets/image/icon-point-active2.png" alt="포인트 아이콘" />
                                <span class="font-prompt">{{total_point}}</span>잎
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ul class="tab-contents">
            <li class="tab-content on" v-if="origin_pointList.length > 0">
                <div class="filter-wrap">
                    <figure class="filter-icon"><img src="@/assets/image/icon-filter.png" alt="필터 아이콘"></figure>
                    <ul class="filter-lists">
                        <li class="filter-list" :class="{on : recent}" @click="recentChange()">최신순</li>
                        <li class="filter-list" :class="{on : plus}" @click="plusChange()">적립</li>
                        <li class="filter-list" :class="{on : minus}" @click="minusChange()">차감</li>
                    </ul>
                </div>
                <ul class="reservation-lists pc-flex">
                    <li class="reservation-list" v-for="(log, idx) in pointList" :key="idx">
                        <span class="reservation-status">
                            <div class="status plus" :style="{'background-color':log.color}">
                                {{log.text}}
                            </div>
                        </span>
                        <span class="reservation-date" style="max-width:60%; text-align:center">
                            <span class="reservation-day">
                                {{log.date}}
                            </span>
                            <span class="reservation-time" style="width:auto; line-height: 1.2;" v-html="log.log_message">
                            </span>
                        </span>
                        <strong class="reservation-room" :style="{'color':log.color}" style="width:25%; text-align: right;">
                            {{log.point}}잎
                        </strong>
                    </li>
                </ul>
            </li>
            <div class="no-result" v-else>
                <div class="no-result-txt" v-html="blankMsg">
                </div>
            </div>
        </ul>
    </main>
</div>
</template>

<script>
import Footer from "@/components/common/Footer";

export default {
    components: {
        Footer
    },
    data() {
        return {
            blankMsg: "",
            user_pk: this.$store.state.userInfo.pk,
            name: this.$store.state.userInfo.name,

            recent: true,
            plus: false,
            minus: false,

            origin_pointList: [],
            pointList: [],
            total_point: 0
        };
    },
    computed: {

    },
    async mounted() {
        let sum = 0;
        this.axios.get(`/point?user_pk=${this.user_pk}`).then(res => {
            res.data.result.forEach(log => {
                sum += log.point;
                if (log.point > 0) {
                    log.color = "#206B25";
                    log.point = `+${this.numberComma(log.point.toString())}`;
                    log.text = "적립";
                    log.status = "plus";
                } else if (log.point < 0) {
                    log.color = "#BB3C3C";
                    log.point = `${this.numberComma(log.point.toString())}`;
                    log.text = "차감";
                    log.status = "minus";
                }
                log.date = moment(log.created).format("YY/MM/DD HH:mm");
            });
            this.total_point = `${this.numberComma(sum.toString())}`;

            if (res.data.result.length > 0) {
                this.origin_pointList = res.data.result;
                this.pointList = _.cloneDeep(this.origin_pointList);
            } else {
                this.blankMsg = "포인트 내역이 <br>존재하지 않습니다.";
            }
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        numberComma(value) {
            return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        recentChange() {
            this.recent = !this.recent;
            const order = this.recent ? "desc" : "asc";

            this.pointList = _.orderBy(this.pointList, ["created"], [order]);
        },
        plusChange() {
            this.plus = !this.plus;

            const order = this.recent ? "desc" : "asc";
            this.pointList = _.orderBy(this.origin_pointList, ["created"], [order]);

            if (this.plus) {
                this.minus = false;
                this.pointList = this.origin_pointList.filter(item => item.status === "plus");
            } else {
                this.pointList = this.origin_pointList;
            }
        },
        minusChange() {
            this.minus = !this.minus;

            const order = this.recent ? "desc" : "asc";
            this.pointList = _.orderBy(this.origin_pointList, ["created"], [order]);

            if (this.minus) {
                this.plus = false;
                this.pointList = this.origin_pointList.filter(item => item.status === "minus");
            } else {
                this.pointList = this.origin_pointList;
            }
        }
    }
};
</script>

<style scoped>
.contract-summary {
    margin-bottom: 10px;
    padding: 18px 20px 18px;
}

.contract-price img {
    margin-right: 10px;
    width: 40px;
}

.contract-price-wrap {
    padding: 10px 0 0 0;
}

.service .tab-content {
    padding: 10px 16px 100px;
}

@media (max-width: 600px) {
    .contract-summary {
        margin-bottom: 10px;
        padding: 18px 20px 18px !important;
    }
}
</style>
